<script>

import {axios} from '../mixins';
import {debounce} from "debounce";
import FarmsForm from '../components/Farms/Form.vue';
import FieldsForm from '../components/Fields/Form.vue';
import FieldYearsForm from '../components/FieldYears/Form.vue'
import OperationsForm from '../components/Operations/Form.vue'
import {Alerts} from "../mixins/Alerts.js";
import Dropdown from "./Dropdown.vue";
import Modal from "../components/Modal.vue"
import ContractsSubmit from "./Contracts/Submit.vue"
import {Carousel, Icon, Navigation, Pagination, Slide} from 'vue3-carousel'
import ValidationIcon from "./ValidationIcon.vue";
import 'vue3-carousel/dist/carousel.css';

export default {

  name: 'DataIndex',

  components: {
    ValidationIcon,
    FarmsForm,
    FieldsForm,
    FieldYearsForm,
    OperationsForm,
    Dropdown,
    Modal,
    ContractsSubmit,
    Carousel,
    Slide,
    Icon, Navigation, Pagination
  },

  computed: {
    numberOfFields() {
      if (this.farmDataFiltered.fields) {
        return this.farmDataFiltered.fields.length
      }
      return 0;
    },
    totalFieldAcreage() {
      if (this.farmDataFiltered.fields) {
        const total = this.farmDataFiltered.fields.reduce((acc, field) => acc + parseFloat(field.size), 0)
        return total.toFixed(2); // Round to two decimal places
      }
      return 0
    }
  },

  mixins: [axios],

  props: {
    activeYear: {
      type: Number,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    farm: {
      type: Object,
      required: false,
    },
    mapboxToken: {
      type: String,
      required: true,
    },
    digifarmToken: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    operationTypes: {
      type: Object,
      required: true,
    },
    locked: {
      type: Boolean,
      required: true,
    },
    defaultResource: {
      type: Number,
      required: false,
    },
    defaultResourceType: {
      type: String,
      required: false,
    },
    hasContract: {
      type: Boolean,
      required: false,
      default: false,
    },
    admin: {
      type: Boolean,
      default: false,
      required: false,
    },
    super: {
      type: Boolean,
      required: false,
      default: false,
    },
    additionalityTypes: {
      type: Object,
      required: false,
      default: [],
    }
  },

  data() {
    return {
      farmData: null,
      farmDataFiltered: null,
      fields: null,
      activeFieldYears: null,
      showGreeting: true,
      resource: {
        id: null,
        type: null,
        data: null,
      },
      history: [],
      filter: '',
      alerts: new Alerts(),
      boundaryError: false,
      selectedFieldId: null, // used for passing between index iterations and other parts of template
      selectedFieldName: null,
      selectedYear: null, // used for passing between index iterations and other parts of template
      destinationFields: [], // array of fields to copy data to in bulk clone modal
      years: [],
      yearsList: [],
      update: 0,
      cloning: false,
      activeField: null,
      fieldsCollapsed: true,
      farmIsLocked: true,
      breakpoints: {
        1: {
          itemsToShow: 1,
          snapAlign: 'start',
        },
        640: {
          itemsToShow: 2,
          snapAlign: 'start',
        },
        768: {
          itemsToShow: 3,
          snapAlign: 'start',
        },
        1024: {
          itemsToShow: 4,
          snapAlign: 'start',
        },
        1280: {
          itemsToShow: 5,
          snapAlign: 'start',
        },
        1536: {
          itemsToShow: 6,
          snapAlign: 'start',
        },
        1792: {
          itemsToShow: 7,
          snapAlign: 'start',
        },
        2048: {
          itemsToShow: 8,
          snapAlign: 'start',
        },
      },
      yearIndexStart: 0,
      showContract: false,
      questionsData: null,
      orgName: null,
    };
  },

  created() {
    this.farmIsLocked = this.locked
    this.showContract = this.hasContract;
    this.load()

    window.addEventListener("keydown", this.keyListener);

    // show default
    if (this.defaultResourceType && this.defaultResource) {
      this.showResource(this.defaultResourceType, this.defaultResource)
    }
  },

  methods: {
    keyListener(event) {
      if (event.key === "Escape") {
        this.closeResource()
      } else if (event.key === "[" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault(); // prevent default action from getting triggered.
        this.goBack()
      } else if (event.key === "r" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault(); // prevent default action from getting triggered.
        let data = {
          farmIndex: this.farm.id
        }

        if (this.userId) {
          data.user_id = this.userId
        }

        if (this.resource.type && this.resource.id) {
          data.resource_type = this.resource.type
          data.resource_id = this.resource.id
        }

        let urlParams = '?' + this.urlParams(data)

        location.href = this.url + urlParams
      }
    },

    getYears() {
      let yearArray = [];
      let difference = this.super ? 10 : 5;
      for (let i = this.activeYear - difference; i <= this.activeYear + difference + 1; i++) {
        yearArray.push(i);
      }
      this.years = yearArray
    },

    load() {
      let urlParams = ''
      if (this.userId) {
        urlParams = this.urlParams({user_id: this.userId})
      }
      this.get('/content/' + this.farm.id + '?' + urlParams).then((response) => {
        let firstLoad = this.farmData === null

        this.getYears();

        this.orgName = response.data.orgName;
        this.farmData = response.data.data;
        this.questionsData = response.data.questionsData;
        // Clone farm
        this.farmDataFiltered = null;
        this.farmDataFiltered = JSON.parse(JSON.stringify(this.farmData));
        this.fields = this.farmDataFiltered.fields;

        if (firstLoad) {
          setTimeout(() => {
            if (this.$refs.focusname) {
              let searchComponent = this.$refs.focusname[0]
              if (searchComponent) {
                searchComponent.focus()
              }
            }
          }, 300);

          this.activeField = this.farmDataFiltered['fields'][0].id;
        } else {
          this.filterItems()
        }
        this.update += 1;

        this.scrollCarouselToYear()
      });
    },

    addToHistory(resourceToAdd) {
      let arr = this.history.slice();
      arr.unshift(resourceToAdd);
      this.history = arr
    },

    goBack() {
      let lastResource = this.history[0];
      if (lastResource) {
        this.history = this.history.slice(1)
        //temp to solve slowness issue
        this.showResource(lastResource.type, lastResource.id, lastResource.data, true)

        if (lastResource.type === null) {
          this.scrollToActive()
          this.scrollCarouselToYear()
        }
      }
    },

    showResource(type, id, resourceData = null, skipTrackHistory = false) {
      this.showGreeting = false
      this.alerts.initialize()
      if (!skipTrackHistory) {
        this.addToHistory(this.resource);
      }

      if (id) {
        this.get(type + '/' + id).then((response) => {
          this.resource = {
            id: id,
            type: type,
            data: response.data.resource,
          }
          if (type === 'fields') {
            this.activeField = id
          }
          this.selectedYear = this.resource.data.year ?? this.activeYear
        })
        window.scrollTo(0,0)
      } else {
        this.resource = {
          id: id, // null
          type: type,
          data: resourceData,
        }
        this.scrollToActive()
      }
    },

    updateResource(resource) {
      this.alerts.initialize()
      this.patch(resource.type + '/' + resource.id, resource.data).then((response) => {
        this.resource = {
          id: resource.id,
          type: resource.type,
          data: response.data.resource,
        }

        this.load()
        this.showResource()
        this.closeResource()
      }).catch((errors) => {
        this.alerts.recordErrors(errors.response.data.errors)
      });
    },

    storeResource(resource) {
      this.alerts.initialize()
      if (resource.type) {
        this.post(resource.type, resource.data).then((response) => {
          this.resource = {
            id: response.data.resource.id,
            type: resource.type,
            data: response.data.resource,
          }
          this.load()
          this.showResource()
          this.closeResource()
        }).catch((errors) => {
          this.alerts.recordErrors(errors.response.data.errors)
          if (resource.type === 'fields' && this.alerts.getError('boundary')) {
            this.boundaryError = true;
          }
        });
      }
    },

    deleteResource(resource) {
      this.alerts.initialize()
      this.delete(resource.type + '/' + resource.id).then(() => {

        if (resource.type == 'farms') {
          location.href = this.url + '?' + 'user_id=' + this.userId
        } else {
          this.load()
          this.showResource()
          this.goBack()
        }
      })
    },

    closeResource() {
      this.alerts.initialize()
      this.resource = {
        id: null,
        type: null,
        data: null,
      }
      this.scrollToActive()
      this.scrollCarouselToYear()
    },

    validateResource(resource) {
      let messages
      this.get('/validate/' + resource.type + '/' + resource.id).then((response) => {
        messages = response.data.errors
        if (messages.length === 0) {
          messages = [
            ['Data is valid.']
          ]
        }

        let refResource = this.$refs[resource.type + `-` + resource.id]
        if (Array.isArray(refResource)) {
          refResource = refResource[0]
        }
        refResource.setMessages(messages)

      }).catch((errors) => {
        messages = [
          ['Failed to load errors.']
        ]

        let refResource = this.$refs[resource.type + `-` + resource.id]
        if (Array.isArray(refResource)) {
          refResource = refResource[0]
        }
        refResource.setMessages(messages)
      });

    },

    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key)) {
          out.push(key + '=' + encodeURIComponent(myData[key]));
        }
      }
      return out.join('&');
    },

    dropdownAction(selected) {
      switch (selected.name) {
        case 'Bulk Clone':
          this.selectedFieldId = selected.field_id
          this.selectedYear = selected.year
          this.$refs.cloneModal.open();
          break;
        case 'Edit':
          this.showResource(selected.resource_type, selected.resource_id, selected.resource_data)
          break;
        case 'Set Intervention Year':
          this.setInterventionYear(selected.resource_id)
          break;
        case 'Additionality':
          this.selectedYear = selected.year;
          this.selectedYear.name = selected.field;
          this.$refs.additionalitiesModal.open();
          break;
        case 'Clone Operations':
          this.selectedFieldName = selected.fieldName;
          this.selectedFieldId = selected.fieldId;
          this.$refs.cloneAllModal.open();
          break;
        case 'Delete':
          this.selectedYear = selected.year;
          this.selectedYear.type = 'field_years';
          this.selectedFieldName = selected.field;
          this.$refs.deleteModal.open();
          break;
        default:
          break;
      }
    },

    cloneOperations(fieldId, year, fieldYearToClone) {
      this.cloning = true
      this.alerts.initialize()

      let data = {
        field_id: fieldId,
        year: year,
        field_year_to_clone_id: fieldYearToClone,
      }

      this.post('/field_years/clone', data).then((response) => {
        if (response.data.status === 'failed') {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.load()
        }
        this.cloning = false
        this.$refs.cloneModal.close()
        this.selectedFieldId = null
        this.selectedYear = null

        this.scrollToActive()
        this.scrollCarouselToYear()
      }).catch(() => {
        this.cloning = false
      });
    },

    // Clone entire field's operations to another field
    cloneAllOperations(fieldId) {
      this.cloning = true;
      this.alerts.initialize();

      console.log(fieldId)
      let data = {
        field_id: fieldId,
        destination_fields: this.destinationFields,
      }

      this.post('fields/clone', data).then((response) => {
        if (response.data.status === "failed") {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.load()
        }

        this.cloning = false;
        this.destinationFields = []
        this.$refs.cloneAllModal.close()
        this.selectedFieldId = null;

        this.scrollToActive()
        this.scrollCarouselToYear()
      }).catch(() => {
        this.cloning = false
      })
    },

    debounceInput: debounce(function () {
      this.filterItems()
    }, 50),

    filterItems() {
      let arr
      if (this.filter && this.filter !== '') {
        arr = []
        arr = this.farmData.fields.filter((field) => {
          return ((field.name).toLowerCase()).includes(this.filter.toLowerCase())
        })
        this.farmDataFiltered['fields'] = arr

        if (this.numberOfFields === 1) {
          this.activeField = this.farmDataFiltered['fields'][0].id
        }
      } else {
        this.clearFilter()
      }
    },

    clearFilter() {
      this.filter = '';
      this.farmDataFiltered = JSON.parse(JSON.stringify(this.farmData))
    },

    scrollToActive() {
      if (this.activeField) {
        setTimeout(() => {
          let element = document.getElementById('fields-' + this.activeField)
          if (element) {
            element.scrollIntoView()
          }
        }, 200);
      }
    },

    scrollCarouselToYear() {
      this.$nextTick(function () {
        this.yearIndexStart = this.years.indexOf(this.selectedYear ?? this.activeYear) - 1
        const carouselRef = 'carousel-' + this.activeField;
        if (this.$refs[carouselRef]) {
          this.$refs[carouselRef][0].slideTo(this.yearIndexStart)
        }
      })
    },

    toggleField(fieldId) {
      if (this.activeField === fieldId) {
        this.activeField = null
      } else {
        this.activeField = fieldId
      }

      this.scrollCarouselToYear()
    },

    setInterventionYear(fieldYearId) {
      let data = {field_year_id : fieldYearId}
      this.post('field_years/set-intervention-year', data).then((response) => {
        if (response.data.status === 'error') {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.load()
        }
        this.scrollToActive()
        this.scrollCarouselToYear()
      })
    },
    barStatus(fieldYear, interventionYear, years) {
      years = [...new Set(([this.years, years]).flat().sort())]
      let result = '';
      if (fieldYear < interventionYear) {
        result += 'bg-yellow '
      } else {
        result += 'bg-green '
      }
      if (fieldYear === interventionYear || fieldYear === years[0]) {
        result += 'rounded-l-lg '
      }
      if (fieldYear === interventionYear - 1 || fieldYear === years[years.length - 1]) {
        result += 'rounded-r-lg '
      } else {
        result += '-mr-4 '
      }
      return result;
    },

    addAdditionality(fieldYear) {
      let additionality = {};
      additionality.type = null;
      additionality.text_box = false;
      fieldYear.additionalities.push(additionality)
    },

    additionalityTextInput(additionality) {
      additionality.text_box = (event.target.value === 7 || event.target.value === '7');
    },

    setAdditionalities(fieldYear) {
      this.post('additionalities/set-additionalities', fieldYear).then((response) => {
        if (response.data.errors) {
          this.alerts.recordErrors([response.data.message])
        } else {
          this.load()
        }
        this.scrollToActive()
      })
    },
  },
};

</script>

<template>
  <div class="flex flex-col text-white" :key="this.update">
    <div class="w-full text-white mb-4 bg-grey-dark rounded-md p-6" v-if="!this.resource.type">
      <div v-if="showGreeting" class="mb-4">
        <slot name="welcome"></slot>
      </div>

      <p>
        If you are ready to submit your application, click the button below:
      </p>
      <ContractsSubmit :userId="userId" :farmId="farm.id" v-if="!resource.type"
                       :disabled="!!(farmIsLocked || farm.contract_id)"
                       :orgName="this.orgName"
                       @submitted="farmIsLocked = true"
                       @show="showResource"></ContractsSubmit>
    </div>

    <template v-if="alerts.getErrors().length">
      <div id="error-display" class="flex flex-row mb-12 bg-grey-darkest rounded-lg p-8 text-red border-red border-3">
        <ul class="flex-1">
          <li v-for="error in alerts.getErrors()">
            {{ error }}
          </li>
        </ul>
        <div class="">
          <button class="text-white" @click="alerts.initialize()"><i class="fas fa-times"></i></button>
        </div>
      </div>
    </template>

    <!--   INDEX VIEW   -->
    <div v-if="!resource.type && farmDataFiltered">
      <div class="flex">
        <div class="w-1/2 md:w-1/4 text-white text-3xl text-center rounded-t-md bg-grey-darkest py-2">
          Fields & Operations
        </div>
        <div v-show="this.showContract" class="w-1/2 md:w-1/4 text-white text-3xl text-center rounded-t-md bg-blue-dark py-2">
          <a :href="`/user/` + this.userId">
            Contract Review
          </a>
        </div>
      </div>
      <div class="mb-12 bg-grey-darkest rounded-tr rounded-b p-8">

        <div class="flex flex-col md:flex-row">
          <!-- Farm Title -->
          <button :id="`farms-` + farmDataFiltered.id" :title="`farms-` + farmDataFiltered.id" type="button"
                  class="flex flex-row text-4xl w-full text-left mb-2 md:mb-0"
                  @click="showResource('farms',farmDataFiltered.id)">
            {{ farmDataFiltered.name }}
            <span class="ml-2">
                  <ValidationIcon resourceType="farms" :resourceId="farmDataFiltered.id"
                                  :isValid="farmDataFiltered.is_valid"
                                  :ref="`farms-` + farmDataFiltered.id"
                                  @validate="validateResource">
                        <template #is-valid="valid">
                          <slot name="is-valid" :valid="valid.valid"></slot>
                        </template>
                  </ValidationIcon>
            </span>
            <span class="ml-2">
              <span>{{ totalFieldAcreage + " Acres"}}</span>
            </span>
          </button>

          <!-- Search -->
          <div class="float-right flex flex-row">
            <div>
              <input placeholder="Search Fields" type="text" id="field-search"
                     class="bg-grey text-white border-b py-2 border-grey-light w-full px-3 leading-tight focus:outline-none focus:bg-grey-light text-md rounded-lg"
                     ref="focusname"
                     @input="debounceInput()" v-model="filter">
            </div>
          </div>
        </div>
        <div v-for="field in this.fields" class="border-b border-white py-4 px-4"
             :id="`fields-` + field.id">
          <div class="flex flex-col rounded-lg w-full">
            <div class="flex flex-row">
              <button :title="`fields-` + field.id" type="button"
                      class=" flex flex-row text-2xl flex-1 text-left"
                      @click="showResource('fields',field.id)">
                  <span :class="!field.is_included ? 'line-through text-70' : ''">{{ field.name }}</span>
                  <button v-on:mouseenter="field.tooltip = true" v-on:mouseleave="field.tooltip = false" class="pl-2" v-if="!field.is_included">
                    <div class="relative">
                      <div :class="field.tooltip ? 'visible' : 'hidden'" class="w-96 bg-grey-dark p-2 border border-grey-light rounded absolute left-0 bottom-0 transformz">
                        <span>This field has been excluded from your contract.</span>
                      </div>
                    </div>
                    <i class="fas fa-question-circle"></i>
                  </button>
                <div class="pl-2">
                  <ValidationIcon resourceType="fields" :resourceId="field.id" :isValid="field.is_valid"
                                  :ref="`fields-` + field.id"
                                  @validate="validateResource">
                    <template #is-valid="valid">
                      <slot name="is-valid" :valid="valid.valid"></slot>
                    </template>
                  </ValidationIcon>
                </div>
                <span class="pl-2">
                  <span>{{ field.size + " Acres"}}</span>
                </span>
              </button>
              <div class="font-semibold text-white hover:text-blue border rounded-lg border-white w-10 h-10 mx-2 text-center">
                <Dropdown
                    :options="[{
                      name: (this.admin && !farmIsLocked) ? 'Clone Operations' : null,
                      fieldName: field.name,
                      fieldId: field.id,
                    }]"
                    :closeOnOutsideClick="true"
                    v-on:updateOption="dropdownAction"
                ></Dropdown>
              </div>
              <div v-if="fieldsCollapsed">
                <button type="button" @click="toggleField(field.id)" title="Toggle field"
                        class="font-semibold text-white hover:text-blue border rounded-lg border-white w-10 h-10">
                      <span v-show="activeField !== field.id">
                        <i class="fas fa-caret-left"></i>
                      </span>
                  <span v-show="activeField === field.id">
                        <i class="fas fa-caret-down"></i>
                      </span>
                </button>
              </div>
            </div>
            <div class="w-full py-4"
                 v-if="!fieldsCollapsed || activeField === field.id">
              <carousel :ref="`carousel-${field.id}`" v-model="yearIndexStart" :breakpoints="breakpoints" :mouseDrag="false">
                <slide v-for="(year,index) in [...new Set(([this.years, field.years]).flat().sort())]" :key="index">
                  <div class="h-full mx-2 w-full">
                    <div v-if="field.intervention_year"
                         class="min-w-full p-4 mb-2 overflow-visible"
                         :class="this.barStatus(year, field.intervention_year, field.years)"> </div>
                    <div class="rounded bg-grey-light p-2">
                      <div class="flex justify-between bg-grey-dark rounded-lg p-2">
                        <h3 class="text-xl font-semibold">
                          <button type="button" class="hover:text-blue flex flex-row" @click="showResource('field_years', field.field_years[year] ? field.field_years[year].id: null, field.field_years[year] ? null : {
                                              field_id: field.id,
                                              field_name: field.name,
                                              year: year,
                                            })">
                            {{ year }}
                            <div class="pl-2" v-if="field.field_years[year]"
                                 :id="`field_years-` + year.id">
                              <ValidationIcon resourceType="field_years" placement="bottom"
                                              :resourceId="field.field_years[year].id"
                                              :isValid="field.field_years[year].is_valid"
                                              :ref="`field_years-` + field.field_years[year].id"
                                              @validate="validateResource">
                                <template #is-valid="valid">
                                  <slot name="is-valid" :valid="valid.valid"></slot>
                                </template>
                              </ValidationIcon>
                            </div>
                          </button>
                        </h3>
                        <div v-if="!farmIsLocked || (farmIsLocked && field.field_years[year] && this.admin)">
                          <Dropdown :options="[
                            {
                              name: !farmIsLocked ? 'Bulk Clone' : null,
                              field_id: field.id,
                              year: year
                            },
                            {
                              name: !farmIsLocked ? 'Edit' : null,
                              resource_type:'field_years',
                              resource_id: field.field_years[year] ? field.field_years[year].id : null,
                              resource_data: field.field_years[year] ? null : {field_id: field.id,year: year}
                            },
                            {
                              name: (this.admin && !farmIsLocked) ? 'Set Intervention Year' : null,
                              resource_id: field.field_years[year] ? field.field_years[year].id : null,
                            },
                            {
                              name: (field.field_years[year] && this.admin) ? 'Additionality' : null,
                              year: field.field_years[year] ?? null,
                              field: field.name ?? null,
                            },
                            {
                              name: (field.field_years[year] && !farmIsLocked) ? 'Delete' : null,
                              field: field.name ?? null,
                              year: field.field_years[year],
                            }]"
                              :closeOnOutsideClick="true"
                              v-on:updateOption="dropdownAction"
                          ></Dropdown>
                        </div>
                      </div>
                      <div class="bg-grey-dark rounded-lg mt-2 font-semibold" v-if="field.field_years[year] ? field.field_years[year].intervention_year : false">Intervention Year</div>
                      <div class="text-sm mt-2">
                        <template v-if="field.field_years[year]">
                          <button :id="operation.type + '-' +operation.id"
                                  type="button"
                                  class="flex flex-row w-full font-semibold text-left bg-grey-dark p-2 rounded mt-1 border-b border-grey cursor-pointer hover:bg-grey hover:border-blue"
                                  @click="showResource(operation.type,operation.id)"
                                  :key="operation.type + '-' + operation.id"
                                  v-for="operation in field.field_years[year].operations">
                            <span class="pr-2 text-sm font-normal font-mono">{{ operation.date }}</span>

                            <span class="border-l border-white pl-2"
                                  v-if="operation.type === 'tillages' && operation.meta">NO-TILL</span>
                            <span class="border-l border-white pl-2" v-else>{{ operation.type_name }} {{ operation.crop_id }} <span
                                v-if="['plantings', 'harvests', 'cover_crops'].includes(operation.type)">: {{
                                operation.type === 'cover_crops'
                                    ? (options.cover_crops_crop_id[operation.cover_crop_species]
                                        ? options.cover_crops_crop_id[operation.cover_crop_species].label : operation.crop_name)
                                    : operation.crop_name
                              }}</span></span>

                            <span class="flex-grow text-right" v-if="operation.is_valid" title="Data is valid.">
                                    <slot name="is-valid" :valid="true"></slot>
                                  </span>
                            <span class="flex-grow text-right" v-else>
                                    <ValidationIcon :resourceType="operation.type" :resourceId="operation.id"
                                                    placement="left"
                                                    :isValid="operation.is_valid"
                                                    :ref="operation.type + `-` + operation.id"
                                                    @validate="validateResource">
                                      <template #is-valid="valid">
                                        <slot name="is-valid" :valid="valid.valid"></slot>
                                      </template>
                                    </ValidationIcon>
                                  </span>
                          </button>
                        </template>
                        <button type="button" class="w-full text-left my-2 hover:text-blue" v-if="!farmIsLocked"
                                @click="showResource('operations', null, {
                                          field_year_id: field.field_years.year ? field.field_years.year.id : null,
                                          field_id: field.id,
                                          year: year,
                                        })">
                          Add an operation...
                        </button>
                      </div>
                    </div>
                  </div>
                </slide>
                <template #addons>
                  <Navigation>
                    <template #next>
                      <i class="fas fa-chevron-right text-sm"/>
                    </template>
                    <template #prev>
                      <i class="fas fa-chevron-left text-sm"/>
                    </template>
                  </Navigation>
                  <Pagination />
                </template>
              </carousel>
            </div>
          </div>
        </div>

        <div v-if="farmDataFiltered.fields && (farmDataFiltered.fields.length === 0)">
          <p>
            No fields found. <a href="#" v-if="filter" class="text-blue" @click="clearFilter">Click here to clear
            search filter.</a>
          </p>
        </div>
        <div class="flex flex-row items-start">
          <div class="flex-initial">
            <button v-if="!farmIsLocked" type="button"
                    class="text-2xl border border-white hover:bg-grey-dark rounded-lg my-2 mr-1 p-2 h-full"
                    @click="showResource('fields', null, {farm_id: farmDataFiltered.id, farm_boundaries: farmData.boundary})">
              <i class="fas fa-plus"></i> Manually Create New Field
            </button>
          </div>
          <div class="flex-initial">
            <a :href="`farms/`+ farm.id +`/precision-ag`"><button v-if="!farmIsLocked" type="button"
                    class="text-2xl border border-white hover:bg-grey-dark rounded-lg my-2 ml-1 p-2 h-full">
              <i class="fas fa-external-link"></i> Import Field(s) from John Deere Operations Center
            </button></a>
          </div>
        </div>
      </div>
    </div>

    <!--   RESOURCE VIEW   -->
    <div v-else class="bg-grey-darkest rounded-lg p-8 mb-4">
      <div>
        <div class="w-full text-left text-lg">
          <button type="button" @click="goBack()"
                  class="font-semibold text-white hover:text-blue border rounded-lg border-white px-2 py-1 whitespace-nowrap">
            <i class="fas fa-arrow-left mr-1"></i>
            Back
          </button>
        </div>

        <!--    FORM COMPONENT      -->
        <div>
          <template v-if="resource.type === 'farms'">
            <FarmsForm :resource="resource"
                       :mapboxToken="mapboxToken"
                       :digifarmToken="digifarmToken"
                       @show="showResource"
                       @store="storeResource"
                       @update="updateResource"
                       :locked="farmIsLocked"
                       @delete="deleteResource"
                       :alerts="alerts"
                       :questionsData="this.questionsData">
              <template #create-farm="">
                <slot name="create-farm"></slot>
              </template>
            </FarmsForm>
          </template>

          <template v-else-if="resource.type === 'fields'">
            <FieldsForm :resource="resource"
                        :farmBoundaries="farmData.boundary"
                        :farmAddress="farmData.address"
                        :zipCode="farmData.zipcode"
                        :mapboxToken="mapboxToken"
                        :digifarmToken="digifarmToken"
                        :options="options"
                        @store="storeResource"
                        :locked="farmIsLocked"
                        :years="this.years"
                        :boundaryError="this.boundaryError"
                        @show="showResource"
                        @update="updateResource"
                        @delete="deleteResource" :alerts="alerts">
              <template #create-field="">
                <slot name="create-field"></slot>
              </template>
            </FieldsForm>
          </template>

          <template v-else-if="resource.type === 'field_years'">
            <FieldYearsForm :resource="resource" :mapboxToken="mapboxToken" :options="options" @show="showResource"
                            @store="storeResource"
                            :locked="farmIsLocked"
                            @update="updateResource"
                            @delete="deleteResource"
                            :alerts="alerts"
                            :admin="admin"></FieldYearsForm>
          </template>

          <template
              v-else-if="Object.values(operationTypes).find(obj => {return obj === resource.type}) || resource.type ==='operations'">
            <OperationsForm :resource="resource" :options="options" @store="storeResource"
                            :locked="farmIsLocked"
                            :types="operationTypes"
                            @update="updateResource"
                            @delete="deleteResource" :alerts="alerts">
              <template #create-operation="">
                <slot name="create-operation"></slot>
              </template>
              <template #tillage="">
                <slot name="tillage"></slot>
              </template>
              <template #manure="">
                <slot name="manure"></slot>
              </template>
              <template #fertilizer="">
                <slot name="fertilizer"></slot>
              </template>
              <template #planting="">
                <slot name="planting"></slot>
              </template>
              <template #chemical="">
                <slot name="chemical"></slot>
              </template>
              <template #cover-crops="">
                <slot name="cover-crops"></slot>
              </template>
              <template #harvest="">
                <slot name="harvest"></slot>
              </template>
              <template #irrigation="">
                <slot name="irrigation"></slot>
              </template>
              <template #grazing="">
                <slot name="grazing"></slot>
              </template>
              <template #forage-management="">
                <slot name="forage-management"></slot>
              </template>
            </OperationsForm>
          </template>
        </div>
      </div>
    </div>

    <!--    VALIDATION WINDOW      -->
    <div class="bg-grey-darkest rounded-lg p-8 flex flex-col"
         v-if="this.resource.type && this.resource.data.is_valid!=null">

      <div class="text-4xl w-full text-left">
        Valid for Submission
        <slot name="is-valid"
              :valid="this.resource.data ? this.resource.data.is_valid : true"></slot>
      </div>
      <div>
        <ul class="text-red">
          <li v-for="error in this.resource.data.errors">
            {{ error[0] }}
          </li>
        </ul>
      </div>
    </div>

    <!--   CLONE MODAL   -->
    <Modal ref="cloneModal" :small="true">
      <div class="w-full bg-grey p-2 overflow-auto h-96" aria-orientation="vertical" aria-labelledby="options-menu">
        <template v-if="!cloning && farmData">
          <p class="text-xl">Select a field year below below to copy ALL operation data from that field's crop
            year.</p>
          <div v-for="(field_to_clone) in farmData.fields" class="text-lg">
            <h3 class="bg-grey-dark w-full p-1 italic">{{ field_to_clone.name }}</h3>
            <a href="#" v-for="(field_year_to_clone) in field_to_clone.field_years"
               class="block px-4 py-2 text-sm hover:bg-grey-light"
               role="menuitem" @click="cloneOperations(selectedFieldId, selectedYear, field_year_to_clone.id)">
              {{ field_year_to_clone.year }} <span class="italic">{{ field_year_to_clone.crop }}</span>
            </a>
          </div>
        </template>
        <div v-show="cloning" class="p-4">
          <i class="fas fa-cog fa-spin"></i> Cloning operations...
        </div>
      </div>
      <template #toggle="{open}"></template>
      <template #footer="{cancel}">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                <button type="button"
                        class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-grey-light hover:bg-grey focus:bg-grey-darker mt-2 font-bold mr-2"
                        v-on:click="cancel">
                  Cancel
                </button>
              </span>
      </template>
    </Modal>

    <!--  ALL FIELD OPERATIONS CLONE MODAL  -->
    <Modal ref="cloneAllModal" :small="true">
      <div class="w-full bg-grey p-2 overflow-auto h-96" aria-orientation="vertical" aria-labelledby="options-menu">
        <template v-if="!cloning && farmData">
          <p class="text-xl">Select fields below to copy ALL operational data from {{ this.selectedFieldName }} to selected fields.</p>
          <h3 class="bg-grey-dark w-full p-1 italic">{{ farm.name }}</h3>
          <div v-for="(destinationField) in farmData.fields" class="text-lg mt-1">
            <div v-if="destinationField.name !== this.selectedFieldName">
              <label :for="destinationField.id">
                <input type="checkbox" v-model="destinationFields" :value="destinationField.id" :id="'field-' + destinationField.id">
                <span class="m-2 font-semibold">
                  {{ destinationField.name }}
                </span>
              </label>
            </div>
          </div>
        </template>
        <div v-show="cloning" class="p-4">
          <i class="fas fa-cog fa-spin"></i> Cloning operations...
        </div>
      </div>
      <template #toggle="{open}"></template>
      <template #footer="{cancel}">
        <button type="button"
                class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mx-2"
                @click="cloneAllOperations(selectedFieldId)">
          Clone
        </button>
        <span class="mt-3 flex flex-grow w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button type="button"
                    class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-grey-light hover:bg-grey focus:bg-grey-darker mt-2 font-bold mx-2"
                    v-on:click="cancel">
              Cancel
            </button>
          </span>
      </template>
    </Modal>

    <!-- ADDITIONALITIES MODAL -->
    <Modal ref="additionalitiesModal" :small="true">
      <div class="w-full bg-grey p-2 overflow-auto h-96" aria-orientation="vertical" aria-labelledby="options-menu">
        <template v-if="this.selectedYear">
          <div class="my-2 font-semibold text-xl">{{ this.selectedYear.name }} {{ this.selectedYear.year }} Additionalities</div>
            <div v-for="(additionality, index) in this.selectedYear.additionalities" class="my-4 flex justify-between items-center bg-grey-dark">
              <div class="m-2">{{ additionality.delete ? 'Deleted' : ('Practice ' + index) }}</div>
              <div class="flex items-center" v-show="!additionality.delete">
                <div class="flex flex-col justify-between items-center items-stretch">
                  <select class="m-2 p-2 bg-grey-darkest" v-model="additionality.type" @change="additionalityTextInput(additionality)">
                    <option v-for="(additionalityType, index) in this.additionalityTypes" v-bind:value="index">
                      {{ additionalityType }}
                    </option>
                  </select>
                  <input v-show="additionality.text_box || additionality.type === (7 || '7')" v-model="additionality.practice_name" class="bg-grey-darkest p-2 m-2" placeholder="Enter practice..."/>
                </div>
                <button class="p-2 font-semibold" @click="additionality.delete = true;">X</button>
              </div>
            </div>
          <button class="p-2 my-2 bg-grey-light text-center font-semibold" v-on:click="addAdditionality(this.selectedYear)">Add New</button>
        </template>
      </div>
      <template #footer="{close}">
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button type="button"
                  class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-grey-light hover:bg-grey focus:bg-grey-darker mt-2 font-bold mr-2"
                  v-on:click="close">
            Close
          </button>
          </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mr-2"
                  v-on:click="setAdditionalities(this.selectedYear)">
            Save
          </button>
        </span>
      </template>
    </Modal>

    <!--   DELETE MODAL   -->
    <Modal ref="deleteModal" :small="true">
      <div class="w-full bg-grey p-2" aria-orientation="vertical" aria-labelledby="options-menu">
        <template v-if="this.selectedYear">
          <div class="text-lg font-semibold">
            Are you SURE you want to delete the field year {{ this.selectedYear.year }} for {{ this.selectedFieldName }}?
          </div>
        </template>
      </div>
      <template #toggle="{open}"></template>
      <template #footer="{cancel}">
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button type="button"
                  class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-grey-light hover:bg-grey focus:bg-grey-darker mt-2 font-bold mr-2"
                  v-on:click="cancel">
            Cancel
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mr-2"
                  v-on:click="deleteResource(this.selectedYear)">
            Confirm
          </button>
        </span>
      </template>
    </Modal>
  </div>
</template>
